import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PageLayout from "../layouts/PageLayout";
import Laporan from "../pages/Laporan/Laporan";
import LoginPage from "../pages/LoginPage/LoginPage";
import StokBarang from "../pages/StokBarang/StokBarang";
import Transaksi from "../pages/Transaksi/Transaksi";
import Pengaturan from "../pages/Pengaturan/Pengaturan";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import ThemeComponent from "../components/ThemeComponent/ThemeComponent";
import Kategori from "../pages/Kategori/Kategori";
import RegisterPage from "../pages/RegisterPage/RegisterPage";
import BuatTokoPage from "../pages/BuatTokoPage/BuatTokoPage";
import VerifikasiEmailPage from "../pages/VerifikasiEmailPage/VerifikasiEmailPage";
import LupaPassword from "../pages/LupaPassword/LupaPassword";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import Halaman404 from "../pages/Halaman404/Halaman404";
import HalamanStruk from "../pages/HalamanStruk/HalamanStruk";
import PreOrderPage from "../pages/PreOrderPage/PreOrderPage";
import FakturPembelianPage from "../pages/FakturPembelianPage/FakturPembelianPage";
import StokOpnamePage from "../pages/StokOpnamePage/StokOpnamePage";
import MetodePembayaranPage from "../pages/MetodePembayaranPage/MetodePembayaranPage";

export default function Routes() {
    return (
        <Router>
            <Switch>
                <PrivateRoute path="/pengaturan">
                    <ThemeComponent>
                        <PageLayout>
                            <Pengaturan />
                        </PageLayout>
                    </ThemeComponent>
                </PrivateRoute>
                <PrivateRoute path="/transaksi">
                    <ThemeComponent>
                        <PageLayout>
                            <Transaksi />
                        </PageLayout>
                    </ThemeComponent>
                </PrivateRoute>
                <PrivateRoute path="/metode-pembayaran">
                    <ThemeComponent>
                        <PageLayout>
                            <MetodePembayaranPage />
                        </PageLayout>
                    </ThemeComponent>
                </PrivateRoute>
                <PrivateRoute path="/stok">
                    <ThemeComponent>
                        <PageLayout>
                            <StokBarang />
                        </PageLayout>
                    </ThemeComponent>
                </PrivateRoute>
                <PrivateRoute path="/kategori">
                    <ThemeComponent>
                        <PageLayout>
                            <Kategori />
                        </PageLayout>
                    </ThemeComponent>
                </PrivateRoute>
                <PrivateRoute path="/laporan">
                    <ThemeComponent>
                        <PageLayout>
                            <Laporan />
                        </PageLayout>
                    </ThemeComponent>
                </PrivateRoute>
                <PrivateRoute path="/pre-order">
                    <ThemeComponent>
                        <PageLayout>
                            <PreOrderPage />
                        </PageLayout>
                    </ThemeComponent>
                </PrivateRoute>
                <PrivateRoute path="/faktur-pembelian">
                    <ThemeComponent>
                        <PageLayout>
                            <FakturPembelianPage />
                        </PageLayout>
                    </ThemeComponent>
                </PrivateRoute>
                <PrivateRoute path="/stok-opname">
                    <ThemeComponent>
                        <PageLayout>
                            <StokOpnamePage />
                        </PageLayout>
                    </ThemeComponent>
                </PrivateRoute>
                <PrivateRoute path="/buat-ukm">
                    <BuatTokoPage />
                </PrivateRoute>
                <PublicRoute path="/" exact>
                    <LoginPage />
                </PublicRoute>
                <PublicRoute path="/registrasi">
                    <RegisterPage />
                </PublicRoute>
                <PublicRoute path="/verifikasi">
                    <VerifikasiEmailPage />
                </PublicRoute>
                <Route path="/lupa-kata-sandi">
                    <LupaPassword />
                </Route>
                <Route path="/atur-kata-sandi">
                    <ResetPassword />
                </Route>
                <Route path="/struk/:slug">
                    <HalamanStruk />
                </Route>
                <Route path="*">
                    <Halaman404 />
                </Route>
            </Switch>
        </Router>
    );
}
